import { render, staticRenderFns } from "./processKpsrNonImprove.vue?vue&type=template&id=3003181d"
import script from "./processKpsrNonImprove.vue?vue&type=script&lang=js"
export * from "./processKpsrNonImprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3003181d')) {
      api.createRecord('3003181d', component.options)
    } else {
      api.reload('3003181d', component.options)
    }
    module.hot.accept("./processKpsrNonImprove.vue?vue&type=template&id=3003181d", function () {
      api.rerender('3003181d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/dashboard/processRam/processKpsrNonImprove.vue"
export default component.exports